import { getMessageFactory } from "../getCaxaWebSocket.js";
const createDrawingsFile = getMessageFactory({
  code: "CREATE_DRAWINGS_FILE"
});
export { createDrawingsFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createDrawingsFile.js